import { sendEvent } from '@nubank/www-latam-commons/services/analytics';

const track = (category, label) => {
  sendEvent('ACCOUNT_INTERACTIONS', { category, label });
};

export default {
  carousel: () => {
    track('carousel', 'interaction');
  },
  calculator: () => {
    track('calculator', 'interaction');
  },
  quickNavigation: label => {
    track('quick_navigation', label);
  },
  faq: () => {
    track('faq', 'interaction');
  },
};
